import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-204e9864"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      type: "flex",
      justify: "center",
      align: "middle",
      gutter: [16, 0]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { flex: "88px" }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "card-icon",
              style: _normalizeStyle(`background-image: url(${_ctx.icon})`)
            }, null, 4)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { flex: "auto" }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.desc), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}